import { Component, OnInit } from '@angular/core';
import { GlobalService } from '../../global.service';
@Component({
  selector: 'app-banner-chat',
  templateUrl: './banner-chat.component.html',
  styleUrls: ['./banner-chat.component.sass']
})
export class BannerChatComponent implements OnInit {

  constructor(private global:GlobalService) { }

  ngOnInit() {
  }
  irChat(){
    this.global.irChat();
  }
  
}
